import { CloseOutlined } from '@mui/icons-material';
import { Box, Button, Divider, IconButton, StepConnector, TextField, Typography } from '@mui/material';
import dayjs from 'dayjs';
import useTranslation from 'hooks/useTranslation/useTranslation';
import React from 'react';
import styled from 'styled-components';
import ComponentWrapper from 'ui/templates/ComponentWrapper/ComponentWrapper';

interface Props {
  handleClose: () => void;
  cardName: string;
  cardDescription: string | undefined;
  cardBlockedTime: dayjs.Dayjs;
}

const StyledStepConnector = styled(StepConnector)`
  & span {
    height: 100%;
  }
`;

const BlockedCard: React.FC<React.PropsWithChildren<Props>> = ({
  handleClose,
  cardBlockedTime,
  cardName,
  cardDescription
}) => {
  const { translation } = useTranslation();

  return (
    <Box
      id="block-card-modal"
      style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        backgroundColor: '#252525',
        border: '1px solid #444',
        borderRadius: '4px'
      }}
    >
      <ComponentWrapper width="444px" flexDirection="column">
        <ComponentWrapper padding="16px 24px" justifyContent="space-between" alignItems="center">
          <Typography variant="h6" color="textPrimary">
            {translation.block}
          </Typography>
          <IconButton onClick={handleClose} style={{ padding: '4px' }}>
            <CloseOutlined style={{ color: 'rgba(255, 255, 255, 0.56)' }} />
          </IconButton>
        </ComponentWrapper>
        <Divider />
        <ComponentWrapper padding="16px 24px" flexDirection="column" gap="24px">
          <ComponentWrapper gap="4px">
            <Typography variant="body2" color="textPrimary">
              {translation.card}
            </Typography>
            <Typography variant="body2" color="textPrimary" id="blocked-card-name">
              {cardName}
            </Typography>
            <Typography variant="body2" color="textPrimary">
              {translation.was_blocked_on}
            </Typography>
            <Typography variant="body2" color="textPrimary" id="blocked-card-date">
              {cardBlockedTime.format('DD-MM-YYYY HH:mm')}
            </Typography>
          </ComponentWrapper>
          <TextField
            disabled
            variant="outlined"
            InputLabelProps={{ shrink: true }}
            size="medium"
            multiline
            label={translation.description}
            value={cardDescription}
            id="drawer-input-reason"
          />
        </ComponentWrapper>
        <Divider />
        <ComponentWrapper padding="8px" alignItems="center" justifyContent="end" gap="8px">
          <Button onClick={handleClose} size="medium" variant="text" style={{ color: 'rgba(255, 255, 255, 0.87) ' }}>
            {translation.close}
          </Button>
        </ComponentWrapper>
      </ComponentWrapper>
    </Box>
  );
};

export default BlockedCard;
